module.exports = __webpack_public_path__ + "img/updateCard.045635a7.svg";